<template src="./list.html"></template>

<script>

import QuestionService from 'Services/QuestionService';
import UserService from 'Services/UserService';
import STATUS_CODE from 'Utilities/constant/statusCode';

export default {
  data() {
    return {
      questionJP: {},
      questionVN: {},
      first_name: null,
      last_name: null,
      email: null,
      line_phone: null,
      contact_type: 1,
      content_question: null,
      message: null,
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const paramsJP = {
        i18n: this.i18n,
        type: 1,
      };

      const paramsVN = {
        i18n: this.i18n,
        type: 2,
      };

      QuestionService.question(paramsJP)
        .then((response) => {
          this.questionJP = response.data;
        })
        .catch(() => {});
      QuestionService.question(paramsVN)
        .then((response) => {
          this.questionVN = response.data;
        })
        .catch(() => {});
    },
    showConfirm() {
      const options = { title: this.$t('contact.title'), cancelLabel: this.$t('contact.cancel'), okLabel: this.$t('contact.confirm') };
      this.$dialogs.confirm(this.$t('contact.message'), options)
        .then(() => {
          this.create();
        });
    },
    create() {
      const params = this.parseParams();
      UserService.create(params)
        .then(() => {
          this.$router.push({ name: 'contact' });
          this.resetParams();
        })
        .catch((errors) => {
          if (errors.status === STATUS_CODE.UNPROCESSABLE_ENTITY) {
            this.$setValidationErrors(errors.status, errors.data);
          } else {
            this.message = 'Vui lòng thử lại';
          }
        });
    },

    parseParams() {
      const params = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        line_phone: this.line_phone,
        content_question: this.content_question,
        contact_type: this.contact_type,
      };
      return params;
    },

    resetParams() {
      this.first_name = null;
      this.last_name = null;
      this.email = null;
      this.line_phone = null;
      this.contact_type = 1;
      this.content_question = null;
    },
  },
};
</script>
<style scoped>
pre {
    text-align: justify;
    white-space: pre-line;
}
</style>
